<template>
  <div class="ag-grid-container">
    <ag-grid-vue
      ref="agGrid"
      class="ag-theme-material"
      style="width: 100%; height: 310px;"
      :columnDefs="columnDefs"
      :gridOptions="gridOptions"
      :rowData="rows"
      :defaultColDef="defaultColDef"
    >
    </ag-grid-vue>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
const labelColors = {
  Colaboración: "#6a00ce", // Colaboración
  Creación: "#ff00ff", // Creación
  Competencia: "#00d8d8", // Competencia
  Control: "#FECC0E", // Control
};
export default {
  name: "ResultsTable",
  components: { AgGridVue },

  data() {
    return {
      defaultColDef: {
        // flex: 1,
        // minWidth: 80,
        resizable: true,
        sortable: true,
        filter: true,
      },
      gridOptions: {
        context: {
          componentParent: this,
        },
        domLayout: "autoHeight",
        overlayNoRowsTemplate: `
          <div class="custom-no-rows">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><g fill="none"><path fill="#ffb02e" d="M15.999 29.998c9.334 0 13.999-6.268 13.999-14c0-7.73-4.665-13.998-14-13.998C6.665 2 2 8.268 2 15.999s4.664 13.999 13.999 13.999"/><path fill="#fff" d="M10.42 19.224a4.206 4.206 0 1 0 0-8.411a4.206 4.206 0 0 0 0 8.411m11.148.077a4.244 4.244 0 1 0 0-8.489a4.244 4.244 0 0 0 0 8.49"/><path fill="#402a32" d="M10.017 6.37c-.19.703-.525 1.355-1.065 1.83c-.533.467-1.307.8-2.452.8a.5.5 0 0 0 0 1c1.355 0 2.373-.4 3.112-1.049c.73-.642 1.146-1.49 1.37-2.32a.5.5 0 1 0-.965-.262m11.966.001c.19.703.525 1.355 1.065 1.83c.533.467 1.307.8 2.452.8a.5.5 0 0 1 0 1c-1.355 0-2.373-.4-3.112-1.049c-.73-.642-1.146-1.49-1.37-2.32a.5.5 0 1 1 .965-.262M16 23c-1.286 0-2.014.428-2.293.707a1 1 0 0 1-1.414-1.414C13.013 21.573 14.286 21 16 21c1.64 0 2.981.567 3.707 1.293a1 1 0 0 1-1.414 1.414C18.019 23.433 17.228 23 16 23m-2-8a3 3 0 1 1-6 0a3 3 0 0 1 6 0m10 0a3 3 0 1 1-6 0a3 3 0 0 1 6 0"/><path fill="#3f5fff" d="M1 19.5a2.5 2.5 0 0 1 5 0v4a2.5 2.5 0 0 1-5 0z"/></g></svg>
            <p style="color: #7a7a7a">No hay procesos creados aún</p>
          </div>
        `,
      },

      columnDefs: [
        {
          headerName: "Cultura",
          field: "cultura",
          width: 160,
          cellStyle: (params) => {
            const value = params.value;
            if (labelColors[value])
              return { color: labelColors[value], fontWeight: "600" };
            else return { color: "#333", fontWeight: "600" };
          },
        },

        {
          headerName: "% Actual",

          field: "actual",
          flex: 1,
          minWidth: 90,
          headerClass: "header-actual",
          valueFormatter: (p) => `${p.value.toFixed(1)}%`,
        },

        {
          headerName: "% Deseada",
          field: "deseada",
          flex: 1,
          minWidth: 90,
          headerClass: "header-deseada",
          valueFormatter: (p) => `${p.value.toFixed(1)}%`,
        },

        {
          headerName: "% Brecha",
          field: "brecha",
          flex: 1,
          minWidth: 90,
          valueFormatter: (p) =>
            p.data.cultura === "Sin dominancia"
              ? "-"
              : `${p.value.toFixed(1)}%`,
          cellStyle: (params) => {
            if (params.data.cultura === "Sin dominancia")
              return { color: "#7f8c8d" };
            const value = params.value;
            if (Math.abs(value) >= 15)
              return { color: "#c0392b", fontWeight: "600" }; // Rojo
            if (Math.abs(value) < 15)
              return { color: "#27ae60", fontWeight: "600" }; // Verde
            return { color: "#7f8c8d" };
          },
        },
      ],
    };
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      if (this.$refs.agGrid && this.$refs.agGrid.api) {
        this.$refs.agGrid.api.sizeColumnsToFit();
      }
    },
  },
  props: {
    rows: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style>
@import "~ag-grid-community/styles/ag-grid.css";
@import "~ag-grid-community/styles/ag-theme-material.css";

/* Color del encabezado % Actual */

.ag-theme-material {
  font-family: "Poppins", sans-serif !important;
}
.header-actual .ag-header-cell-label {
  color: #d04e8c !important; /* azul */
  font-weight: 600;
}

/* Color del encabezado % Deseada */
.header-deseada .ag-header-cell-label {
  color: #4a90e2 !important; /* morado */
  font-weight: 600;
}

.ag-header-cell-label {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/cultura/sections/results/ResultsTable.vue